// import Script from 'next/script';
import React from 'react';


export const GetLang: React.FC = () => {

  const NODE_ENV = process.env.NODE_ENV;
  let url = '';
  if (NODE_ENV !== 'production') {
    url = 'https://www.unify-test-3.bybit.com/common-static/infra-static/brain/getlang.0.0.17.js';
  }else{
    url = '/common-static/infra-static/brain/getlang.0.0.17.js';
  }


  return (
    <script data-index="0.9" crossOrigin="anonymous" src={url} />
  );
  // return <script crossOrigin="anonymous"  src={url} />;
};
